import React from 'react'
import "./ImageScreen.css"
import image from "../../Images/Screenshot.png"
import imageShow from "../../Images/Screenshot (1).png"
export default function ImageScreen(props) {
  return (
    <div style={{ position: 'relative', width: '250px', height: '219px' }}>
  <img className='imagescreen' style={{ width: '100%', height: '100%' }} />
  <div style={{
   position: 'absolute',
    top: '35%', left: '50%',
     transform: 'translate(-50%, -50%)',
     width:"85%",height:"60%" }}>
    <img className='inner-image' src={imageShow} alt="Inner Image" style={{ width: '100%', height: '100%' }} />
  </div>
</div>

  )
}
